import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class DeductionPlanResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.deductionPlan).get(options);
  }

  get(id) {
    return this.$resource(apis.deductionPlan + id).get();
  }

  search(search = "", params) {
    return this.$resource(apis.deductionPlan).get(assign(params, { search }));
  }

  post(item) {
    return this.$resource(apis.deductionPlan).save(item);
  }

  activate(id) {
    return this.$resource(apis.deductionPlan + id + "activate").save(id);
  }

  deactivate(id) {
    return this.$resource(apis.deductionPlan + id + "deactivate").save(id);
  }

  update(id, item) {
    return this.$resource(apis.deductionPlan + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default DeductionPlanResource;



// WEBPACK FOOTER //
// ./src/resources/deductionPlan/deductionPlan.resource.js